<template>
	<AsiDialogFormLayout :icon="icons.state" :title="$t('customer.state')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6">
			<v-form v-model="valid">
				<v-row>
					<v-col>
						<AsiSelect v-model="state" :label="$t('customer.state')" :placeholder="$t('customer.state')"
						           :items="options" :rules="rules"/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import {ValidationRule} from "@/declarations/ValidationRule";
	import {ICustomerAdmin} from "@/models/customer/CustomerAdminModels";
	import {CustomerState} from "@/helpers/constants";
	import EnumHelper from "@/helpers/EnumHelper";
	import AsiSelect from "@/components/common/AsiSelect";
	import CustomerRules from "@/models/customer/CustomerRules";

	@Component({
		components: {AsiSelect, AsiDialogFormLayout}
	})
	export default class CustomerUpdateDialogState extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public customer!: ICustomerAdmin;

		private state: CustomerState | null = null;

		// noinspection JSMethodCanBeStatic
		private get options(): { text: string, value: string | number }[] {
			return EnumHelper.toSelectItems(CustomerState, true);
		}

		// noinspection JSMethodCanBeStatic
		private get rules(): ValidationRule[] {
			return CustomerRules.stateRules;
		}

		@Watch('customer.state', {immediate: true})
		private onCustomerStateChanged(value: CustomerState): void {
			this.state = value;
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.state = this.customer.state;
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		private requestSave(): void {
			if (this.state === null) return;

			this.loading = true;
			this.$customerServiceAdmin.updateState(this.customer.id, this.state)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

	}
</script>

<style lang="scss" scoped>

</style>
